<template>
  <div class="order-delivery-pickup-selector">
    <div class="order-delivery-pickup-selector_title">
      Выберите пункт выдачи
    </div>
    <div class="order-delivery-pickup-selector_row">
      <div
        class="order-delivery-pickup-selector_list"
        :data-delivery-id="getDeliveryItem.id">
        <VueScrollbar :maxHeight="heightSlider">
          <div
            v-for="item in getDeliveryPickupItems"
            :key="item.id"
            :class="{active: item.selected}"
            class="order-delivery-pickup-selector_list-item"
            @click="onClickItem(item.id)">
            <div class="title">{{ item.title }}</div>
            <div class="description">{{ item.description }}</div>
          </div>
        </VueScrollbar>
      </div>
      <div
        ref="mapWrapper"
        class="order-delivery-pickup-selector_map">
        <yandexMap
          ref="map"
          :setting="mapSettings"
          :zoom="zoom"
          :coords="getCoords">
          <ymapMarker
            v-for="item in getDeliveryPickupItems"
            :marker-id="item.id"
            :key="item.id"
            :coords="[item.lat, item.lon]"
            :icon="markerIcon"
            :balloon-template="getBalloonTemplate(item)"
          />
        </yandexMap>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'
  import VueScrollbar from 'vue-scrollbar-live'
  import {yandexMap, ymapMarker} from 'vue-yandex-maps'
  import 'vue-scrollbar-live/lib/css/index.css'
  import axios from 'axios'

  export default {
    name: 'PickupTypeMap',
    components: {
      VueScrollbar,
      yandexMap,
      ymapMarker
    },
    data: function () {
      return {
        zoom: 17,
        heightSlider: 550,
        mapSettings: {
          apiKey: '',
          lang: 'ru_RU'
        },
        markerIcon: {
          layout: 'default#imageWithContent',
          imageHref: '/local/templates/bit_aitech1/images/maps-icon.png',
          imageSize: [24, 34],
          imageOffset: [-12, -17]
        }
      }
    },
    mounted: function () {
      window.$(this.$refs.mapWrapper).on('click', '.balloon-container .button', this.onClickBalloon.bind(this))
      window.addEventListener('resize', this.changeHeightSlider.bind(this))
      this.changeHeightSlider()
    },
    computed: {
      ...mapGetters('order', [
        'getDeliveryPickupItems',
        'getDeliveryPickupItemSelected',
        'getDeliveryItemSelected',
        'getDeliveryFieldByCode'
      ]),
      getCoords: function () {
        return [
          this.getDeliveryPickupItemSelected.lat,
          this.getDeliveryPickupItemSelected.lon
        ]
      },
      getDeliveryItem: function () {
        this.pickupChangeHandler()
        return this.getDeliveryItemSelected
      }
    },
    methods: {
      ...mapMutations('order', [
        'setDeliveryPickupItemById',
        'setDeliveryServiceFiledValueByCode'
      ]),
      getBalloonTemplate: function (item) {
        return `<div class="balloon-container">
          <div class="name">${item.title}</div>
          <div class="desc">${item.description}</div>
          <div class="button" data-id="${item.id}">Выбрать</div>
          </div>`
      },
      onClickBalloon: function (e) {
        let id = e.target.dataset.id
        this.changeSelectedItem(id)
        this.$refs.map.myMap.balloon.close()
      },
      onClickItem: function (id) {
        this.changeSelectedItem(id)
      },
      changeSelectedItem: function (id) {
        this.setDeliveryPickupItemById(id)
        this.zoom = 17
        // hack set zoom
        this.$refs.map.myMap.setZoom(this.zoom)
        this.pickupChangeHandler()
      },
      changeHeightSlider: function () {
        if (window.innerWidth < 768) {
          this.heightSlider = 300
        } else {
          this.heightSlider = 550
        }
      },
      pickupChangeHandler: function () {
        if (!this.getDeliveryItemSelected) {
          return
        }

        switch (this.getDeliveryItemSelected.id) {
          case 176:
            this.dpdHandler()
            break
          case 173:
            this.storePickupHandler()
            break
          case 182:
            this.boxberryHandler()
            break
          case 167:
            this.energyHandler()
            break
          case 171:
            this.sdekHandler()
            break
          case 198:
            this.russianPostHandler()
            break
          case 195:
            this.ozonPostHandler()
            break
        }
      },
      ozonPostHandler: function () {
        this.setDeliveryServiceFiledValueByCode({
          code: 'ADDRESS',
          value: this.getDeliveryPickupItemSelected.title
        })
      },
      russianPostHandler: function () {
        this.setDeliveryServiceFiledValueByCode({
          code: 'ADDRESS',
          value: this.getDeliveryPickupItemSelected.title
        })
        this.setDeliveryServiceFiledValueByCode({
          code: 'ZIP',
          value: this.getDeliveryPickupItemSelected.description
        })
        this.setDeliveryServiceFiledValueByCode({
          code: 'RUSSIANPOST_TYPEDLV',
          value: 'PARCEL_CLASS_1'
        })
      },
      dpdHandler: function () {
        this.setDeliveryServiceFiledValueByCode({
          code: 'PCL',
          value: this.getDeliveryPickupItemSelected.id
        })

        this.setDeliveryServiceFiledValueByCode({
          code: 'ADDRESS',
          value: this.getDeliveryPickupItemSelected.description
        })
      },
      storePickupHandler: function () {
        const location = this.getDeliveryFieldByCode('LOCATION').value
        const street = this.getDeliveryPickupItemSelected.description
        const address = `${location}, ${street}`
        this.setDeliveryServiceFiledValueByCode({
          code: 'ADDRESS',
          value: address
        })

        console.log(this.getDeliveryPickupItemSelected)

        this.setDeliveryServiceFiledValueByCode({
          code: 'PICKUP_STORE',
          value: this.getDeliveryPickupItemSelected.id
        })
        this.$store.dispatch('order/calculateMovingAvailability')
      },
      boxberryHandler: function () {
        const code = this.getDeliveryPickupItemSelected.id
        const location = this.getDeliveryPickupItemSelected.description
        const address = `Boxberry: ${location} #${code}`

        this.setDeliveryServiceFiledValueByCode({
          code: 'ADDRESS',
          value: this.getDeliveryPickupItemSelected.description
        })

        const bodyFormData = new FormData()
        bodyFormData.set('save_pvz_id', this.getDeliveryPickupItemSelected.id)
        bodyFormData.set('change_location', this.getDeliveryFieldByCode('LOCATION').data.shortName)
        bodyFormData.set('address', location)
        axios.post('/bitrix/js/up.boxberrydelivery/ajax.php', bodyFormData, {
          headers: {'Content-Type': 'multipart/form-data'},
          baseURL: '/'
        })

        this.setDeliveryServiceFiledValueByCode({
          code: 'ADDRESS',
          value: address
        })
      },
      energyHandler: function () {
        const location = this.getDeliveryFieldByCode('LOCATION').value
        const street = this.getDeliveryPickupItemSelected.description
        const address = `${location}, ${street}`

        this.setDeliveryServiceFiledValueByCode({
          code: 'ADDRESS',
          value: address
        })
      },
      sdekHandler: function () {
        const city = this.getDeliveryFieldByCode('LOCATION').data.shortName
        const street = this.getDeliveryPickupItemSelected.description
        const code = this.getDeliveryPickupItemSelected.id
        const address = `${city}, ${street} #${code}`

        this.setDeliveryServiceFiledValueByCode({
          code: 'ADDRESS',
          value: address
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/Delivery/PickupTypeMap.vue